import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 2px solid ${({ theme }) => theme.color.gray[200]};
  padding: 18px 8px;
`;
